<template>
    <div
        class="folder"
        :class="{ [color]: true, shadow: !newFolder, 'new-folder': newFolder }"
    >
        <header :class="{ folded: isFolded }">
            <div class="title-wrapper" @click="folderClickHandler">
                <div class="title">{{ title }}</div>

                <div class="links" v-if="!isFolded && links && links.length">
                    <a
                        v-for="(link, index) in links"
                        :key="index"
                        :href="link.url"
                        :class="link.color"
                        >{{ link.text }}</a
                    >
                </div>
                <div
                    v-if="!newFolder && expandable"
                    class="arrow"
                    :class="{ expand: !isFolded }"
                ></div>
            </div>
            <div v-if="actions && !isFolded" class="actions">
                <span
                    class="action"
                    :class="{ 'action-active': currentTab === 0 }"
                    @click="activeAction"
                >
                    Текущие
                </span>
                <span
                    class="action"
                    :class="{ 'action-active': currentTab === 1 }"
                    @click="finishedAction"
                >
                    Завершенные
                </span>
            </div>
        </header>

        <footer v-if="!isFolded">
            <slot></slot>
        </footer>
    </div>
</template>

<script>
export default {
    name: 'Folder',
    props: {
        title: String,
        links: Array,
        actions: Boolean,
        color: {
            type: String,
            default: 'white',
        },
        isFoldedDefault: {
            type: Boolean,
            default: false,
        },
        newFolder: {
            type: Boolean,
            default: false,
        },
        expandable: {
            type: Boolean,
            default: true,
        },
    },
    data: () => ({
        isFolded: false,
        currentTab: 0,
    }),
    mounted() {
        this.isFolded = this.isFoldedDefault;
    },
    methods: {
        activeAction() {
            this.currentTab = 0;
            this.$emit('active', 0);
        },
        finishedAction() {
            this.currentTab = 1;
            this.$emit('finished', 1);
        },
        folderClickHandler() {
            if (!this.newFolder && this.expandable) {
                this.isFolded = !this.isFolded;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/mrem';

.folder {
    font-family: 'Circe Rounded';
    display: flex;
    flex-direction: column;
    margin-bottom: rem(20);

    @include on-mobile {
        margin-bottom: mrem(16);
    }
}

.shadow {
    background-color: #fff;
    border-radius: 0.2rem;

    @include on-mobile {
        padding: mrem(16) 0;
        margin-bottom: mrem(18);
    }

    header {
        @include on-mobile {
            padding: 0 mrem(20);
        }
    }

    footer {
        @include on-mobile {
            padding: 0 mrem(20);
        }
    }
}

.new-folder {
    @include on-mobile {
        margin-bottom: mrem(8);
    }

    header {
        padding: 0;
        margin-bottom: rem(20);

        @include on-mobile {
            margin-bottom: mrem(18);
        }
    }

    footer {
        padding: 0;

        @include on-mobile {
            margin-top: 0;
        }
    }
}

header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: rem(32) rem(32) rem(24);

    &.folded {
        padding-bottom: rem(32);
    }

    @include on-mobile {
        display: block;
        padding: mrem(16) 0;

        &.folded {
            padding-bottom: mrem(16);
            box-shadow: none;
        }
    }

    * {
        font-weight: 600;
        user-select: none;
    }

    .title-wrapper {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        @include on-mobile {
            margin-bottom: mrem(16);
        }
    }

    .actions {
        display: flex;
        justify-self: right;
        margin-bottom: mrem(16);

        @include on-desktop {
            margin-bottom: rem(0);
        }

        .action {
            cursor: pointer;
            font-weight: normal;
            display: flex;
            align-items: center;
            font-size: mrem(18);
            line-height: mrem(22);

            &::before {
                content: ' ';
                display: inline-block;
                width: mrem(18);
                height: mrem(18);
                margin-right: mrem(10);
                border: mrem(2) solid #98a0a9;
                border-radius: mrem(11);
            }

            &:first-child {
                &:after {
                    content: ' ';
                    width: mrem(1);
                    height: mrem(15);
                    margin: 0 mrem(10);
                    border-left: mrem(1) solid #000000;
                }
            }

            @include on-desktop {
                font-size: rem(18);
                line-height: rem(22);

                &::before {
                    content: ' ';
                    display: inline-block;
                    width: rem(18);
                    height: rem(18);
                    margin-right: rem(10);
                    border: rem(2) solid #98a0a9;
                    border-radius: rem(11);
                }

                &:first-child {
                    &:after {
                        content: ' ';
                        width: rem(1);
                        height: rem(15);
                        margin: 0 rem(10);
                        border-left: rem(1) solid #000000;
                    }
                }
            }

            &-active {
                color: #4663ab;

                &::before {
                    border: mrem(6) solid #4663ab !important;
                }

                @include on-desktop {
                    &::before {
                        border: rem(6) solid #4663ab !important;
                    }
                }
            }
        }
    }

    .title {
        cursor: pointer;
        font-weight: 700;
        font-size: rem(20);
        line-height: rem(32);
        font-family: Montserrat, sans-serif;

        @include on-mobile {
            font-size: mrem(22);
            line-height: mrem(36);
            font-weight: 600;
        }
    }
}

footer {
    padding: 0 rem(32) rem(32);

    @include on-mobile {
        padding: 0;
    }
}

.links {
    flex-grow: 1;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    * {
        border-bottom: 1px solid;
        font-size: 0.7rem;
        height: 1.2rem;
        margin-left: 0.5rem;
        font-weight: 500;
    }

    .blue {
        color: #0465ac;
        border-color: #c8e5f7;
    }

    .pink {
        color: #ef627d;
        border-color: #ffdadf;
    }
}

.sign {
    font-size: 1.4rem;
    border: 1px solid #4663ab;
    border-radius: rem(4);
    height: rem(26);
    width: rem(26);
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 1rem;
    cursor: pointer;
    position: relative;

    &__minus {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(rem(-7), rem(-1));
        width: rem(14);
        height: rem(2);
        border-radius: rem(1);
        background: #4663ab;
        transition: transform 0.1s linear;

        &--rotate {
            transform: translate(rem(-7), rem(-1)) rotate(90deg);
        }
    }
}

.arrow {
    width: rem(13);
    height: rem(7);
    margin-left: rem(11);
    background: url('~@/assets/images/up(blue).svg') no-repeat center/contain;
    cursor: pointer;
    transform: rotate(180deg);
    transition: transform 0.1s linear;

    &.expand {
        transform: rotate(0deg);
    }

    @include on-mobile {
        width: mrem(10);
        height: mrem(6);
    }
}

@include on-desktop {
    .shadow.blue {
        background-color: #379bf3;

        header {
            * {
                color: #ffffff;
            }
        }

        .arrow {
            background: url('~@/assets/images/up(white).svg') no-repeat
                center/contain;
        }

        .sign {
            border: solid rem(1) #ffffff;

            &__minus {
                background-color: #ffffff;
            }
        }
    }
}

@import '~@/styles/variables';
@media (max-width: $vm) {
    .shadow {
        background-color: #fff;
        display: flex;
        flex-direction: column;
        border-radius: mrem(4);
        //padding: mrem(16);
        //padding: 0;
    }

    .links {
        flex-grow: 1;
        display: flex;
        justify-content: flex-end;
        align-items: center;

        * {
            border-bottom: solid mrem(4);
            font-size: mrem(16);
            height: mrem(10);
            margin-left: mrem(5);
            font-weight: 500;
        }

        .blue {
            color: #0465ac;
            border-color: #c8e5f7;
        }

        .pink {
            color: #ef627d;
            border-color: #ffdadf;
        }
    }

    .sign {
        font-size: mrem(18);
        border: solid mrem(1) #4663ab;
        height: mrem(22);
        width: mrem(22);
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: mrem(10);
        cursor: pointer;
        border-radius: mrem(4);

        &__minus {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(mrem(-5), mrem(-1));
            width: mrem(12);
            height: mrem(2);
            border-radius: mrem(1);
            background: #4663ab;
            transition: transform 0.1s linear;

            &--rotate {
                transform: translate(mrem(-5), mrem(-1)) rotate(90deg);
            }
        }
    }

    .arrow {
        width: mrem(10);
        height: mrem(6);
        margin-left: mrem(9);
        background: url('~@/assets/images/up(blue).svg') no-repeat
            center/contain;
        cursor: pointer;
    }

    .title {
        font-size: mrem(24);
        line-height: mrem(32);
        margin-top: mrem(3);
    }
}
</style>
